<template>
    <section class="filtres">
        <div class="content">
            <div class="row spaceBetween">
                <h1>{{$t('filter.title')}}</h1>
                <div class="row">
                    <div class="space"></div>
                    <button class="outline" @click="$emit('wipe')">{{$t('button.wipe')}}</button>
                    <button @click="$emit('filter', filter)">{{$t('button.apply')}}</button>
                </div>
            </div>
        </div>
        <hr>
        <div class="content">
            <label>{{$t('users.role')}}</label>
            <div class="row" v-for="role in roleName" :key="role">
                <input type="checkbox" :id="role" v-model="filter.roleName[role]" checked/> <p>{{role}}</p>
            </div>
            <br>
           
            <div class="column">
                <label>{{$t('users.enterprise')}}</label>
            </div> 
            <div class="column relative">
                <select class="mInput" @click="show.select = !show.select"></select>
                <div v-if="show.select" class="multiSelect">
                    <div v-for="merchant in enterpriseName" :key="merchant">
                        <div class="row">
                            <label class="checkbox">
                                <input type="checkbox" v-model="filter.enterpriseName[merchant]"/>
                                {{merchant}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </section>
</template>

<script>
export default { 
    props: ['options', 'users'],
    data() {
        return {
            roleName: [],
            enterpriseName: [],
            filter: {},
            show: {
                select: false
            }
        }
    },
    mounted() {
        this.getList(),
        this.getDefaultFilter()
    },
    methods: {
        getList() {
            let users = this.users
            let role = []
            let enterprise = []
            for (let i = 0; i < users.length; i++) {
                role[i] = users[i]['role'];
                enterprise[i] = users[i]['company']
            }
            this.roleName = [...new Set(role)]
            this.enterpriseName = [...new Set(enterprise)]
        },
        getDefaultFilter() {
            this.filter = this.options
        }
    }
}
</script>

<style scoped>
.multiSelect {
    position: absolute;
    top: 45px;
    background-color:white;
    width: 218px;
    border: solid 1px lightgrey;
    
}
.checkbox {
    font-weight: 400;
    font-size: 1em;
    width: 100%;
    margin: 0;
    padding-left: 10px;
}
.checkbox:hover {
    background-color: #F1F1F1;
}
</style>